import * as DOCUMENT_NAMES from '../../../../constants/documentNames';

export const getLastDocCreatedInfo = (client) => {
	// console.log('getLastDocCreatedInfo client', client);
	var lastDocInfo;
	if (
		client?.documentInformation?.signatureRequests !== undefined &&
		client?.documentInformation?.signatureRequests !== null
	) {
		//SignatureRequest Object
		var sigReqObj = client?.documentInformation?.signatureRequests;

		// console.log('sigReqObj line 6', sigReqObj);

		//the keys for signatureRequests Object
		var sigReqObjKeys = Object.keys(sigReqObj);

		// console.log('sigReqObjKeys line 11', sigReqObjKeys);

		//The latest key for the last signatureRequests Object
		var lastDocCreatedKey = sigReqObjKeys[sigReqObjKeys.length - 1];

		// console.log('lastDocCreatedKey line 16', lastDocCreatedKey);

		//The latest object for the last signatureRequests Object
		var lastDocCreatedObj = sigReqObj[lastDocCreatedKey];

		// console.log('lastDocCreatedObj line 21', lastDocCreatedObj);

		//get the document's subject (for last doc created)
		var docSubject = lastDocCreatedObj['subject'];

		// console.log('docSubject line 26', docSubject);

		//determining the document's name
		var docName;

		if (docSubject === DOCUMENT_NAMES.aps) {
			docName = 'APS';
		} else if (docSubject === DOCUMENT_NAMES.aps) {
			docName = 'Condo Docs';
		}

		// console.log('docName line 40', docName);

		//get the document's timestamp (again for last doc created)
		var docCreatedTimeStamp = lastDocCreatedObj['timestamp'];

		//get the document's signatureUpdates (you know for which doc hehe)
		var signatureUpdatesObj = lastDocCreatedObj['signatureUpdates'];

		//get that signatureUpdates' keys array
		var signatureUpdatesObjKeys =
			signatureUpdatesObj && Object.keys(signatureUpdatesObj);

		//get the latest key created for signatureUpdates' key array
		var lastSignatureUpdatesObjKey =
			signatureUpdatesObjKeys &&
			signatureUpdatesObjKeys[signatureUpdatesObjKeys.length - 1];

		//get the signature information - from that last key that we got
		var signatureObj =
			signatureUpdatesObj &&
			signatureUpdatesObj[lastSignatureUpdatesObjKey]?.signature_request
				?.signatures;

		//get the signature keys
		var signaturesKeys = signatureObj && Object.keys(signatureObj);

		//now lets structure the data for the signatures
		var signaturesStatusArray = [];

		signaturesKeys?.forEach((key) => {
			var statusCode = signatureObj[key]['status_code'];

			signaturesStatusArray.push(statusCode);
		});

		var mainButtonColor;

		//determining the nature of the signatures
		if (docName === 'APS') {
			// console.log('I am in the APS line 64');
			if (signaturesStatusArray.length >= 6) {
				//@TODO
				//now we are in a aps and having a second client
				if (
					signaturesStatusArray[0] === 'signed' && //client
					signaturesStatusArray[1] === 'signed' && //second client
					signaturesStatusArray[2] === 'signed' && //admin
					signaturesStatusArray[3] === 'signed' //builder
				) {
					// console.log('Everybody has signed the APS');
					mainButtonColor = 'rgba(41, 190, 103, 0.3)';
				} else if (
					signaturesStatusArray[0] === 'signed' &&
					signaturesStatusArray[1] === 'signed' &&
					signaturesStatusArray[2] === 'signed' &&
					signaturesStatusArray[3] !== 'signed'
				) {
					// console.log(
					// 	'Everybody has signed the APS except the builder'
					// );
					mainButtonColor = 'rgba(255, 158, 0, 0.3)';
				} else if (
					signaturesStatusArray[0] === 'signed' &&
					signaturesStatusArray[1] === 'signed' &&
					signaturesStatusArray[2] !== 'signed' &&
					signaturesStatusArray[3] !== 'signed'
				) {
					// console.log(
					// 	'Only the clients and the witnesses have signed'
					// );
					mainButtonColor = 'rgba(255, 158, 0, 1)';
				} else if (
					signaturesStatusArray[0] === 'signed' &&
					signaturesStatusArray[1] !== 'signed' &&
					signaturesStatusArray[2] !== 'signed' &&
					signaturesStatusArray[3] !== 'signed'
				) {
					// console.log('Only the client has signed');
					mainButtonColor = 'rgba(224, 224, 224, 1)';
				} else if (
					signaturesStatusArray[0] !== 'signed' &&
					signaturesStatusArray[1] !== 'signed' &&
					signaturesStatusArray[2] !== 'signed' &&
					signaturesStatusArray[3] !== 'signed'
				) {
					// console.log('No one has signed');
					mainButtonColor = 'rgba(224, 224, 224, 1)';
				}
			} else {
				//now we are in aps and having no second client
				//check if all have signed
				if (
					signaturesStatusArray[0] === 'signed' &&
					signaturesStatusArray[1] === 'signed' &&
					signaturesStatusArray[2] === 'signed'
				) {
					// console.log('Everybody has signed the APS');
					mainButtonColor = 'rgba(41, 190, 103, 0.3)';
				} else if (
					signaturesStatusArray[0] === 'signed' && //check if needs builder signature (admin has signed)
					signaturesStatusArray[1] === 'signed' &&
					signaturesStatusArray[2] !== 'signed'
				) {
					// console.log(
					// 	'Everybody has signed the APS except the builder'
					// );
					mainButtonColor = 'rgba(255, 158, 0, 0.3)';
				} else if (
					signaturesStatusArray[0] === 'signed' && //check if needs builder signature (admin has signed)
					signaturesStatusArray[1] !== 'signed' &&
					signaturesStatusArray[2] !== 'signed'
				) {
					// console.log('Only the client and the witness have signed');
					mainButtonColor = 'rgba(255, 158, 0, 1)';
				} else if (
					signaturesStatusArray[0] !== 'signed' &&
					signaturesStatusArray[1] !== 'signed' &&
					signaturesStatusArray[2] !== 'signed'
				) {
					// console.log('Only the client has signed');
					mainButtonColor = 'rgba(224, 224, 224, 1)';
				}
			}
		} else if (docName === 'Condo Docs') {
			//@TODO
			//now we are in condo docs
			if (signaturesStatusArray.length >= 5) {
				//condo docs having a second purchaser
				// console.log(
				// 	'Condo docs have second purchaser',
				// 	signaturesStatusArray
				// );
			} else {
				//condo docs having no second purchaser
				// console.log(
				// 	'Condo docs have NO second purchaser',
				// 	signaturesStatusArray.length - 1
				// );

				if (
					signaturesStatusArray[signaturesStatusArray.length - 1] ===
					'signed' //Witness
				) {
					// console.log('Condo docs signed');
					mainButtonColor = 'rgba(41, 190, 103, 0.3)';
				} else if (
					signaturesStatusArray[signaturesStatusArray.length - 1] ===
					'awaiting_signature'
				) {
					// console.log('Condo docs awaiting');
					mainButtonColor = 'rgba(255, 158, 0, 0.3)';
				}
			}
		}

		//building the last doc info object
		lastDocInfo = {
			docName: docName,
			timestamp: docCreatedTimeStamp,
			mainButtonColor: mainButtonColor,
		};

		// console.log('lastDocInfo 246', lastDocInfo);

		return lastDocInfo;
	} else {
		lastDocInfo = {
			docName: 'APS',
			timestamp: '-',
			mainButtonColor: 'rgba(224, 224, 224, 1)',
		};

		return lastDocInfo;
	}
};
